import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Municipality } from "@app/project/model/municipality";
import { FormatPhonePipe } from "@app/shared/resources/phone-formatter.pipe";
import { phoneValid } from "@app/shared/validators/phoneValid";

@Component({
    selector: "clare-edit-municipality",
    templateUrl: "./edit-municipality.component.html",
    styleUrls: ["./edit-municipality.component.scss"],
})
export class EditMunicipalityComponent implements OnInit {
    @Output() cancel = new EventEmitter<any>();
    @Output() save = new EventEmitter<any>();
    @Input() updateItem: Municipality = null;

    municipalityForm: FormGroup = this.fb.group({
        firePhone: ["", Validators.compose([Validators.required, phoneValid])],
        policePhone: ["", Validators.compose([Validators.required, phoneValid])],
        auxiliaryPhone: ["", Validators.compose([Validators.required, phoneValid])],
    });

    constructor(private readonly fb: FormBuilder) {}

    ngOnInit(): void {
        if (this.updateItem) {
            this.municipalityForm.patchValue(this.updateItem);
        }
    }

    onChangeMunicipality(event) {
        this.municipalityForm.patchValue(event.value);
    }

    saveAction() {
        Object.values(this.fields).forEach(field => {
            field.markAsTouched({ onlySelf: true });
        });

        const { value, valid } = this.municipalityForm;

        if (valid) {
            const data = {
                firePhone: new FormatPhonePipe().transform(value.firePhone),
                policePhone: new FormatPhonePipe().transform(value.policePhone),
                auxiliaryPhone: new FormatPhonePipe().transform(value.auxiliaryPhone),
            };
            if (this.updateItem) {
                const updateMunicipality = {
                    ...this.updateItem,
                    ...data,
                };
                this.save.emit(updateMunicipality);
            } else {
                this.save.emit(data);
            }
        }
    }

    get fields() {
        return this.municipalityForm.controls;
    }
}
